import React from 'react'

const MicrosoftIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'>
      <g clip-path='url(#clip0_23072_23387)'>
        <path d='M7.60413 7.60413H0V0H7.60413V7.60413Z' fill='#F1511B' />
        <path d='M16.0005 7.60413H8.39648V0H16.0005V7.60413Z' fill='#80CC28' />
        <path d='M7.60394 16.0026H0V8.39844H7.60394V16.0026Z' fill='#00ADEF' />
        <path
          d='M16.0005 16.0026H8.39648V8.39844H16.0005V16.0026Z'
          fill='#FBBC09'
        />
      </g>
      <defs>
        <clipPath id='clip0_23072_23387'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MicrosoftIcon
